import CompanyBadges from './CompanyBadges';

export default CompanyBadges;
